/**
 * Created by koqiui on 2017-04-09.
 */
import {Jqext, Utils} from '../../app.base'
import {Vue} from '../../app.vues'

let Toast = Jqext.Toast;
//
import SwbVideoPlayer from './VideoPlayer.vue';

export function openVedioPlayerDlg(url, poster, allowFullScreen) {
    Vue.regist(SwbVideoPlayer);
    //
    Vue.$showDialog({
        title: '视频播放',
        showCloseBtn: true,
        width: 1080,
        height: 700,
        okVisible: false,
        cancelText: '关闭',
        template: '<div><swb-video-player :url="url" :width="width" :height="height" :poster="poster" :allowFullScreen="allowFullScreen"></swb-video-player></div>',
        data: {
            url: url,
            width: 1000,
            height: 600,
            poster: poster || null,
            allowFullScreen: allowFullScreen || false
        },
        methods: {
            dlgBodyResized(width, height) {
                this.width = width;
                this.height = height;
            }
        }
    });
}

import SwbRepoFileBizRec from './RepoFileBizRec';

Vue.regist(SwbRepoFileBizRec);

export function openRepoFileBizRecDlg(uuid) {
    //
    Vue.$showDialog({
        title: '文件的变更记录',
        showCloseBtn: true,
        width: 1300,
        height: 700,
        okVisible: false,
        cancelText: '关闭',
        template: '<div>' +
            '<swb-repo-file-biz-rec :uuid="uuid" ref="swb-repo-file-biz-rec"></swb-repo-file-biz-rec>' +
            '</div>',
        data: {
            uuid: uuid
        },
        cancelClicked: function () {
        }
    });
}

import SwbFileDownload from './FileDownload.vue'
import SwbFileDownloadGrp from './FileDownloadGrp.vue'
import SwbCmnFuncMetaList from './CmnFuncMetaList.vue'
import SwbVarListEditor from './VarListEditor.vue'

Vue.regist(SwbFileDownload);

/** 单文件下载对话框（title参数 可以省略） */
export function showDownloadDlg(title, fileInfo, xlsExport = false) {
    if (arguments.length == 1) {
        fileInfo = title;
    }
    //
    if (typeof fileInfo == 'string') {
        fileInfo = {
            url: fileInfo
        };
    }
    //
    if (typeof fileInfo.post != 'boolean') {//是否使用post方式
        fileInfo.post = false;
    }
    //
    if (typeof fileInfo.asForm != 'boolean') {//是否使用form方式
        fileInfo.asForm = false;
    }
    //
    if (typeof fileInfo.autoDownload != 'boolean') {//是否自动下载
        fileInfo.autoDownload = true;
    }
    //是否纯xls导出（从而支持“按常规格式输出”选项）
    xlsExport = xlsExport == true;
    //
    if (xlsExport) {//纯xls导出会取消自动下载
        fileInfo.autoDownload = false;
    }
    //
    let theDlg = Vue.$showDialog({
        title: title || '文件下载',
        showCloseBtn: true,
        width: 600,
        height: 150,
        okVisible: false,
        cancelVisible: false,
        template: '<div style="text-align : center">' +
            '<swb-file-download ref="swb-file-download" :url="url" :post="post" :asForm="asForm" :params="params" :data="data" :fileName="fileName" :fileNameHeader="fileNameHeader" :onResult="onResult" :autoDownload="autoDownload" :xlsExport="xlsExport"></swb-file-download>' +
            '</div>',
        data: {
            xlsExport: xlsExport,
            autoDownload: fileInfo.autoDownload,
            //
            url: fileInfo.url,
            post: fileInfo.post,
            asForm: fileInfo.asForm,
            params: fileInfo.params || null,
            data: fileInfo.data || null,
            fileName: fileInfo.fileName || null,
            fileNameHeader: fileInfo.fileNameHeader || null
        },
        methods: {
            onResult(result) {
                if (result.type == 'info') {
                    setTimeout(function () {
                        if (theDlg) {
                            theDlg.close();
                        }
                    }, 3000);
                } else {
                    Toast.show(result.message, 5000, 'warning');
                }
            }
        }
    });
}

Vue.regist(SwbFileDownloadGrp);

/** 批量/按组文件下载对话框，返回对话框对象 */
export function showGrpDownloadDlg(title, fileList, resultCbk/*下载完毕回调(result, thdDlg)*/, nextDelay = 1500/*下个文件延迟ms*/, width = 640, xlsExport = false) {
    if (typeof title != 'string') {
        Toast.show('请指定 批量文件下载对话框 标题', 5000, 'error');
        return;
    }
    if (!Utils.isArray(fileList)) {
        Toast.show('批量文件 列表参数 无效', 5000, 'error');
        return;
    }
    let fileCount = fileList.length;
    if (fileCount < 1) {
        Toast.show('没有需要批量下载的文件', 5000, 'warning');
        return;
    }
    nextDelay = Math.max(nextDelay || 0, 1500);
    if (typeof width == 'boolean') {
        xlsExport = width;
        width = null;
    }
    width = width || 640;
    //是否纯xls导出（从而支持“按常规格式输出”选项）
    xlsExport = xlsExport == true;
    //
    let height = 'auto';
    if (fileCount > 10) {
        height = '80%';
    }
    //
    let theDlg = Vue.$showDialog({
        title: title || '文件下载',
        showCloseBtn: true,
        width: width,
        height: height,
        okVisible: false,
        cancelVisible: false,
        template: '<div style="text-align : center; width: 100%; height: 100%;">' +
            '<swb-file-download-grp style="display:block;" ref="the_file_download_grp" :xlsExport="xlsExport" :nextDelay="nextDelay" :fileList="fileList" :onResult="onResult">' +
            '   <el-button class="fr" style="margin-top:-4px;" v-if="!overDownAll" size="mini" @click="doAutoDownload()" slot="extBtn">{{autoDownloadText}}</el-button>' +
            '</swb-file-download-grp>' +
            '</div>',
        data: {
            xlsExport: xlsExport,
            autoDownload: false,
            autoDownloadText: '开始自动下载',
            overDownAll: false,
            //
            nextDelay: nextDelay,
            fileList: fileList
        },
        methods: {
            doAutoDownload() {
                let the_file_download_grp = this.$refs['the_file_download_grp'];
                if (this.autoDownload) {
                    this.autoDownload = false;
                    this.autoDownloadText = '开始自动下载';
                    the_file_download_grp.stopAutoDownload();
                } else {
                    this.autoDownload = true;
                    this.autoDownloadText = '停止自动下载';
                    the_file_download_grp.startAutoDownload();
                }
            },
            onResult(result) {
                this.overDownAll = true;
                //
                console[result.type](result.message);
                //
                if (typeof resultCbk == 'function') {
                    resultCbk(result, theDlg);
                }
            }
        }
    });
    //
    return theDlg;
}

//允许提交的最大大小（字节数，48M - 预留的 32K）
const MAX_ALLOWED_POST_SIZE = 1024 * 1024 * 48 - 1024 * 32;
const MAX_ALLOWED_POST_HINT = '48M';

/** 打开html转pdf下载对话框 */
export function showHtmlToPdfDlg(fileName, htmlContent, htmlStyle = null) {
    if (!htmlContent) {
        Toast.show('没有内容，已取消导出为pdf', 5000, 'warning');
        return;
    }

    Toast.show('正在估算内容大小...', 15000, 'loading');

    let title = fileName != null ? fileName : 'Html导出为Pdf';
    let targetUrl = '/xutil/htmlToPdf.do';
    if (typeof getAppUrl == 'function') {
        targetUrl = getAppUrl(targetUrl);
    }

    //对提交内容大小进行校验
    var postSize = Utils.getUtf8StrLen(fileName) + Utils.getUtf8StrLen(htmlContent) + Utils.getUtf8StrLen(htmlStyle);
    if (postSize > MAX_ALLOWED_POST_SIZE) {
        Toast.show('内容太大（已接近或达到限制的' + MAX_ALLOWED_POST_HINT + '大小），不支持导出为pdf', 5000, 'warning');
        return;
    }
    Toast.hide();

    let fileInfo = {
        url: targetUrl,
        post: true,
        asForm: true,
        fileName: fileName,
        data: {
            fileName: fileName,
            htmlContent: htmlContent,
            htmlStyle: htmlStyle
        }
    };
    //
    showDownloadDlg(title, fileInfo);
}

/** 打开通用函数选择对话框 */
export function showCmnFuncSelectDlg(dlgConfig, callback) {
    Vue.regist(SwbCmnFuncMetaList);
    //
    dlgConfig = dlgConfig || {};
    let dlgTitle = dlgConfig['dlgTitle'] || '选择函数';
    let dlgWidth = dlgConfig.dlgWidth || 600;
    let dlgHeight = dlgConfig.dlgHeight || 480;
    let funcList = dlgConfig['funcList'] || [];
    let baseType = dlgConfig['baseType'] || 'string';
    let funcName = dlgConfig['funcName'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: dlgTitle,
        width: dlgWidth,//80%
        height: dlgHeight,//80%
        okVisible: true,
        cancelVisible: true,
        centerButtons: true,
        showCloseBtn: false,
        //
        template: '<swb-cmn-func-meta-list ref="theListCtrl" style="width:100%;height:100%;overflow-y:auto;" ' +
            ':funcList="funcList" :baseType="baseType" :funcName="funcName" :dblClickHandler="dblClickHandler"></swb-cmn-func-meta-list>',
        data: {
            funcList: funcList,
            baseType: baseType,
            funcName: funcName
        },
        methods: {
            dblClickHandler(selected) {
                callback(selected);
                //
                theDlg.close();
            }
        },
        okClicked: function () {
            let theListCtrl = this.$refs['theListCtrl'];
            let selected = theListCtrl.getSelected();
            if (selected == null) {
                Toast.show('尚未选中函数');
                return false;
            }
            //
            callback(selected);
        }
    });

}

/** 显示通用变量列表编辑器 callback(selected/varList, theDlg) */
export function openVarListDlg(dlgConfig, callback) {
    Vue.regist(SwbVarListEditor);
    //
    let initHint = dlgConfig['initHint'] || '';//初始
    let varList = dlgConfig['varList'] || [];//初始
    let editable = dlgConfig['editable'] || false;//可编辑
    let fixedType = dlgConfig['fixedType'] || null;//固定类型
    let fixedList = dlgConfig['fixedList'] || false;//保存
    let selectable = dlgConfig['selectable'] || false;
    let dblClickHandler = dlgConfig['dblClickHandler'] || null;
    let dlgTitle = dlgConfig['dlgTitle'] || ('变量 - ' + (editable ? '编辑' : '查看') + (selectable ? '/选择' : ''));
    //
    let theDlg = Vue.$showDialog({
        title: dlgTitle,
        width: 800,
        height: 600,
        showCloseBtn: true,
        okVisible: editable || selectable,
        cancelText: editable || selectable ? '取 消' : "关 闭",
        template: '<div class = "">' +
            '<swb-var-list-editor ref="theEditor" :initHint="initHint" :editable="editable" :fixedType="fixedType" :fixedList="fixedList" :selectable="selectable" :varList="varList" :dblClickHandler="dblClickHandler"></swb-var-list-editor>' +
            '</div>',
        data: {
            initHint: initHint,
            editable: editable,
            fixedType: fixedType,
            fixedList: fixedList,
            selectable: selectable,
            varList: varList
        },
        methods: {
            dblClickHandler(selected) {
                selected = Utils.merge({}, selected);
                if (typeof dblClickHandler == 'function') {
                    dblClickHandler(selected, theDlg);
                } else {
                    if (!this.editable) {
                        callback(selected, theDlg);
                    }
                }
            }
        },
        okClicked: function () {
            let theEditor = this.$refs['theEditor'];
            if (this.editable) {
                if (theEditor.validate()) {
                    callback(theEditor.getData(), theDlg);
                }
                //
                return false;
            } else {
                if (this.selectable) {
                    let selected = theEditor.getSelected();
                    if (selected == null) {
                        Toast.show('未选择任一条目');
                    } else {
                        selected = Utils.merge({}, selected);
                        callback(selected, theDlg);
                    }
                    //
                    return false;
                }
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/ctrl/dialog.js
// module id = 14
// module chunks = 0